// Mock data for Somm.ai replica
export const stats = [
  { value: "47k+", label: "accounts tracked" },
  { value: "40+", label: "major clients" },
  { value: "143k+", label: "skus tracked" },
];

export const salesFeatures = [
  {
    title: "Peer Brands",
    desc: "Find accounts that carry your peer brands but do not carry your brand",
  },
  {
    title: "Account Prestige",
    desc: "Target high prestige accounts to ensure quality of distribution. In addition to Awards (e.g. Michelin Star), we have our own proprietary ratings of accounts",
  },
  {
    title: "Distributor Alignment",
    desc: "Target accounts that already work with your distributor in a particular market",
  },
];

export const platformFeatures = [
  "Access historical wine and spirits lists",
  "Average pricing and pricing changes over time",
  "Supplier and distributor information",
  "Best-in-class high touch customer service",
  "Contact information decision makers at accounts",
  "Custom APIs available upon request",
];

export const clients = [
  { name: "Jackson Family", logo: "https://cdn.prod.website-files.com/63953bb9027db08001043848/63964f29c92e133f549c9450_jackson%20(1).png" },
  { name: "Vintus", logo: "https://cdn.prod.website-files.com/63953bb9027db08001043848/639651d139abd5777f0be103_Vintus.jpg" },
  { name: "Gallo", logo: "https://cdn.prod.website-files.com/63953bb9027db08001043848/66b33b7b0c5a543f6f8bd3c4_Gallo-Logo.png" },
  { name: "Lucas Bols", logo: "https://cdn.prod.website-files.com/63953bb9027db08001043848/649d23e8deb97c4a8d17ba34_LogoLucasBols_orange.svg" },
  { name: "DAOU", logo: "https://cdn.prod.website-files.com/63953bb9027db08001043848/639651d1dd443034766b56dc_DAOU_Logotype_Red_CMYK.png" },
];

export const pricingPlans = [
  {
    name: "Growth+",
    subtitle: "For small brands, importers and distributors looking to grow",
    monthly: 0,
    yearly: 0,
    features: ["All markets", "All brands", "Unlimited Users"],
    featured: false,
  },
  {
    name: "Established+",
    subtitle: "For medium-to-large brands, importers and distributors who need an all-in-one solution",
    monthly: 28,
    yearly: 280,
    prefix: "Everything in Growth+, plus",
    features: ["24 / 7 Support", "White Glove Service", "Unlimited 1x1 training"],
    featured: true,
  },
  {
    name: "Enterprise+",
    subtitle: "For large brands, importers and distributors who need custom solutions",
    monthly: 128,
    yearly: 1280,
    prefix: "Everything in Established+, plus",
    features: ["Custom APIs", "Custom Data Requests", "Custom Development"],
    featured: false,
  },
];

export const faqs = {
  "Privacy & Security": [
    { q: "How do I import my email address list?", a: "Uploading your mailing lists to Somm.ai is super easy. Just create a .txt or .csv file with all the addresses and click on the add member/members option on your dashboard." },
    { q: "How many emails am I allowed to send per month?", a: "No matter what plan you choose, there is no limit to the number of emails you can send out per month." },
    { q: "Do you offer non-profit discounts?", a: "Somm.ai offers discounts to nonprofit agencies and lists for personal non-commercial usage. You can check out the terms and restrictions for the discount here." },
  ],
  "Changelog": [
    { q: "Can I see who reads my email campaigns?", a: "Yes, we offer a read timestamp feature with the standard and pro subscription plans." },
    { q: "Are there any email templates that I can customize?", a: "Yes. Templates are easy ways to pre-format content. Somm.ai provides built-in templates for you to use and also allows you to create your own templates." },
    { q: "How fast is your email delivery?", a: "We can mail up to 800,000 messages an hour." },
  ],
  "Terms & Conditions": [
    { q: "What do you do about rejected emails?", a: "We try to send a message 4 times\u2014one initial send and 3 retries over a 36 hour period. If a mail server reports that an address is permanently non-deliverable, we will only attempt to deliver to it once for that mailing." },
    { q: "Do you have A/B testing for emails?", a: "Yes, you can A/B test with subject lines & preview the entire text before sending your mails out." },
  ],
};
